export default {
  titleOfRecommendedGames: 'Heading.RecommendedGames'
};
